export default "__VITE_ASSET__824e5665__"